<!--<kendo-drawer-container>-->
<!--  <kendo-drawer #drawer [items]="items" [mode]="'push'" [expanded]="false" [autoCollapse]="false"-->
<!--                (select)="onSelect($event)" [mini]="true">-->
<!--  </kendo-drawer>-->
<!--  <ng-template kendoDrawerItemTemplate let-item>-->
<!--  <span class="menuFont">-->
<!--    <i [class]="item.icon"></i>-->
<!--    &lt;!&ndash;        <fa-icon [icon]="item.icon" class="fa-light k-icon k-font-icon" style="margin-right: 10px; font-size: 14px; font-weight: 200"></fa-icon>&ndash;&gt;-->
<!--    @if (drawer.expanded) {-->
<!--      <span>-->
<!--        {{item.text}}-->
<!--      </span>-->
<!--    }-->
<!--  </span>-->
<!--  </ng-template>-->
<!--  <kendo-drawer-content>-->
<!--    <router-outlet></router-outlet>-->
<!--  </kendo-drawer-content>-->
<!--</kendo-drawer-container>-->
<!--<kendo-drawer-container>-->
<kendo-drawer-container>

  <kendo-drawer
    [expanded]="drawerOpen"
    mode="push"
    position="start"
    [mini]="false"
  >
    <ng-template kendoDrawerTemplate>
      <div class="drawer-menu">
        <button kendoButton look="flat" (click)="navigate('smart/formsList')">
           <span style="margin-right: 8px">
            <kendo-icon name="menu"></kendo-icon>
          </span>
          Forms List
        </button>

        <button kendoButton look="flat" (click)="logout()">
           <span style="margin-right: 8px">
            <kendo-icon name="logout"></kendo-icon>
          </span>
          Logout
        </button>

      </div>
    </ng-template>
  </kendo-drawer>

  <kendo-drawer-content>
    <router-outlet></router-outlet>
  </kendo-drawer-content>

</kendo-drawer-container>
